// === Pedagogy Reviewer ===
// Client for POST /api/workflow/review on aidea-middleware. Returns the
// validated review list (one item per critique finding). Authoritative shape:
//   { reviews: [{ severity, category, message, targetItemId? }] }
//
// Errors surface as a thrown Error — the ReviewDrawer catches and renders an
// inline error state rather than letting the failure bubble to the modal.
import { apiPost } from "../../common/http_service";
import { getToken } from "../../common/environment_config";

function authHeaders() {
  const token = getToken();
  const h = { Accept: "application/json" };
  if (token) h.Authorization = "Bearer " + token;
  if (typeof window !== "undefined" && window.tenantId) {
    h["Abp.TenantId"] = window.tenantId;
  }
  return h;
}

function reviewUrl() {
  const base = (typeof window !== "undefined" && window.ideaLibraryRootUrl) || "";
  return `${base.replace(/\/$/, "")}/api/workflow/review`;
}

/**
 * Run a pedagogy review against the current section workflow.
 *
 * @param {string|number} sectionId
 * @param {object} workflowJson  { variables, triggers, items, ... }
 * @returns {Promise<Array<{severity:string, category:string, message:string, targetItemId?:string}>>}
 */
export async function runPedagogyReview(sectionId, workflowJson) {
  if (sectionId === null || sectionId === undefined) {
    throw new Error("runPedagogyReview: sectionId is required");
  }
  const body = {
    sectionId: String(sectionId),
    workflowJson: workflowJson || { variables: [], triggers: [] },
  };
  const response = await apiPost(reviewUrl(), body, { headers: authHeaders() });
  if (!response || !response.ok) {
    const status = response && response.status;
    throw new Error(`Pedagogy review request failed (status=${status})`);
  }
  const text = await response.text();
  let parsed;
  try {
    parsed = text ? JSON.parse(text) : {};
  } catch (e) {
    throw new Error(`Pedagogy review response was not JSON: ${e.message}`);
  }
  const reviews = Array.isArray(parsed && parsed.reviews) ? parsed.reviews : [];
  return reviews;
}
